// PreApply.jsx – Form with EmailJS Integration
import { useRef } from 'react';
import emailjs from 'emailjs-com';

const PreApply = () => {
  const formRef = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs.sendForm(
      'service_fes810k',
      'template_h3igwjg',
      formRef.current,
      'R7eWMQcRk7QSfffhV'
    ).then(() => {
      alert("Submitted successfully! We'll notify you at launch.");
      formRef.current.reset();
    }).catch(err => {
      alert("Submission failed. Try again.");
      console.error(err);
    });
  };

  return (
    <div style={{ maxWidth: "600px", margin: "auto", padding: "2rem" }}>
      <h2 style={{ fontSize: "2rem", color: "#6A0DAD", marginBottom: "1rem" }}>
        Pre-Apply for Pluto Loans 🚀
      </h2>
      <p>Be the first to access AI-powered personal loans. We're launching soon!</p>
      <form ref={formRef} onSubmit={handleSubmit}>
        <label>Your Name</label>
        <input name="name" required />

        <label>Your Email</label>
        <input name="email" type="email" required />

        <label>Your Mobile</label>
        <input name="mobile" required />

        <label>Loan Requirement / Interest</label>
        <input name="interest" placeholder="E.g., ₹5,000 for books" />

        <button type="submit">Submit Interest</button>
      </form>
    </div>
  );
};

export default PreApply;
